import { render } from "./IFrameView.vue?vue&type=template&id=7a26466c&scoped=true"
import script from "./IFrameView.vue?vue&type=script&lang=js"
export * from "./IFrameView.vue?vue&type=script&lang=js"

import "./IFrameView.vue?vue&type=style&index=0&id=7a26466c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a26466c"]])

export default __exports__